import React, { useRef } from 'react'
import { BlockWrapper, defineBlock, useEditor } from '@smartfire/js-block-engine'
import { Slide } from './Slide'
import { postActusParams } from '../types'
import { useMediaQuery } from '../hooks'
import { Autoplay, Pagination, EffectFade } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import { ReactComponent as DecoMobile } from './assets/deco-mobile.svg'
import { ReactComponent as DecoDesktop } from './assets/deco-desktop.svg'
import { selectOption } from '../types'
import 'swiper/css'
import 'swiper/css/effect-fade'
import 'swiper/css/pagination'
import style from './block.module.scss'

interface HomeHeroProps {
    posts: postActusParams[]
    previewPosts: selectOption[]
}

const HomeHero: React.FC<HomeHeroProps> = ({ posts }) => {
    const isMobile = useMediaQuery('(max-width: ' + style.mobileBreakpoint + ')')
    const { isEditing } = useEditor()
    const swiperRef = useRef<any>(null)
    const DecoTag = isMobile ? DecoMobile : DecoDesktop

    const swiperProps = {
        slidesPerView: 1,
        autoplay: { delay: 6000, disableOnInteraction: false },
        fadeEffect: { crossFade: true },
        shortSwipes: isMobile ? true : false,
        touchRatio: isMobile ? 1 : 0,
        pagination: {
            clickable: true,
            enabled: posts && posts.length > 1,
        },
        watchOverflow: true,
        loop: true,
        modules: [Autoplay, Pagination, EffectFade],
    }

    const handleSwipe = (next: number) => {
        if (next === 1) swiperRef?.current?.swiper.slideNext(400)
        else swiperRef?.current?.swiper.slidePrev(400)
    }

    return (
        <BlockWrapper.Div className={style.block}>
            {posts && posts.length > 0 && (
                <>
                    <Swiper
                        {...swiperProps}
                        ref={swiperRef}
                        className={style.swiper}
                        effect={'fade'}
                    >
                        {posts.map((post, i) => (
                            <SwiperSlide key={i + '_' + post.id}>
                                <Slide post={post} handleSwipe={handleSwipe} />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </>
            )}
            <DecoTag className={style.deco} />
            {isEditing && (
                <div className={style.previewBO}>
                    Ce block n'est pas prévisualisable en back office.
                </div>
            )}
        </BlockWrapper.Div>
    )
}

export default defineBlock({
    Block: HomeHero,
    setup: {
        title: 'Home Hero',
    },
})
